import {
    computed,
} from 'vue';
import { useMediaQuery } from '@vueuse/core';

export const BREAKPOINTS = {
    s: '20em', // 320px
    m: '45em', // 720px
    l: '78em', // 1248px
};

export function useBreakpoints() {
    const isLargeScreen = useMediaQuery(`(min-width: ${BREAKPOINTS.l})`);
    const isMediumScreen = useMediaQuery(`(min-width: ${BREAKPOINTS.m})`);
    const isMobile = computed(() => !isMediumScreen.value);

    return {
        isMobile,
        isMediumScreen,
        isLargeScreen,
    };
}
